import React from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';

import {
    localize,
} from 'wanderu-i18n';
import {
    durationToHoursAndMinutes,
} from 'wanderu-utils';

import styles from './Layover.scss';

function Layover(props) {
    const {
        t,
        arriveTimestamp,
        departTimestamp,
    } = props;
    const arrive = moment.parseZone(arriveTimestamp);
    const depart = moment.parseZone(departTimestamp);
    const duration = moment.duration(depart.diff(arrive));

    return (
        <div className={styles.layover}>
            <div className={styles.layoverDuration}>
                <div>
                    {t('baseApp:trip-duration_hours', durationToHoursAndMinutes(duration))}
                </div>
            </div>
            <div className={styles.layoverLineContainer}>
                <div className={styles.layoverLine} />
            </div>
            <div className={styles.layoverText}>
                {t('baseApp:layover_tripDetails')}
            </div>
        </div>
    );
}

Layover.propTypes = {
    arriveTimestamp: PropTypes.string.isRequired,
    departTimestamp: PropTypes.string.isRequired,
};

export {
    Layover,
};
export default localize(Layover, ['t']);
